import { render } from "./PaginateSmBlock.vue?vue&type=template&id=8e231e46"
import script from "./PaginateSmBlock.vue?vue&type=script&lang=js"
export * from "./PaginateSmBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__